import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { AbstractModalContentComponent } from '@ibe.components/common/modal/abstract-modal-content.component';
import { ModalService } from '@ibe/services/ui';
import { takeWhile } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '../../.././store';
import { Store } from '@ngrx/store';
import { RouteTrip } from '@ibe/store/states/mini-ibe.indra.state';
import { INDRABookingSearchService } from '@ibe.services/booking-search.indra.service';
import * as BookedTripActions from '@ibe/store/actions/booked-trip.actions';

@Component({
	selector: 'app-week-flights-discount-modal',
	templateUrl: './weak-flights-discount-modal.indra.component.html',
	styleUrls: ['./week-flights-discount-modal.component.scss']
})
export class INDRAWeakFlightsDiscountModalComponent extends AbstractModalContentComponent implements OnInit, OnDestroy {

	searchRoute$: Observable<Array<RouteTrip>> = this.store.select(fromStore.getMiniIBESearchRoutes);
	searchRoute: RouteTrip;
	amountValue$: Observable<number> = this.store.select(fromStore.getWeakFlightAmt);
	amountValue: any;
	isAlive = true;
	weakFlightsSubscription: Subscription;

	constructor(
		protected modalService: ModalService,
		private store: Store<fromStore.State>,
		private bookingSearchService: INDRABookingSearchService
	) {
		super(modalService);

		this.searchRoute$
			.pipe(takeWhile(() => this.isAlive))
			.subscribe((searchRoute: any) => {
				this.searchRoute = searchRoute;
			});

	}

	ngOnInit() {

		const weakFLightReq = {
			'origin': this.searchRoute[0].departure.code,
			'destination': this.searchRoute[0].arrival.code,
			'fareBasis': [ 'WEAK' ],
			'fareFamily': [ 'WEAK' ]
		};

		this.weakFlightsSubscription = this.bookingSearchService.INDRA_getInformationWeakFlights(weakFLightReq).subscribe(res => {
			if (res && res.status === '200' && res.amount) {
				this.amountValue = {
					'amount': res.amount,
					'currency': res.currency
                };
                this.store.dispatch(new BookedTripActions.PutWeakFlightAmount(this.amountValue));
			}
		});
	}


	ngOnDestroy(): void {
		this.isAlive = false;
		this.weakFlightsSubscription.unsubscribe();
	}

	INDRA_close() {
		this.closeModal();
	}
}
